import {CheckoutRequestHandler, IStateLookup} from "../../../../typescript-library";

type CheckoutRequestHandlerType = {stateLookup: (shopId: number, countryCode: string) => Promise<IStateLookup[]>};

/**
 * This is just copied from the _CountriesFactory.ts_ from tslib including a tiny bug fix
 * see comments
 */
class StatesHelper {
  private awaitingStatesPromise: Promise<IStateLookup[]> | null = null;
  private allStates: {[field: string]: IStateLookup[]} | null = null;

  public async getStates(shopId: number, countryCode: string): Promise<IStateLookup[]> {
    if (this.allStates && this.allStates[countryCode]) {
      return this.allStates[countryCode];
    }

    if (this.awaitingStatesPromise) {
      try {
        await this.awaitingStatesPromise;
      } catch (err) {
        if ((err as Error & {response?: {status: number}}).response?.status !== 400) {
          throw err;
        }
      }

      // THIS is the buggy line (in the tslib), see <code>this.awaitingStatesPromise = null;</code> below
      // return this.awaitingStatesPromise!;

      return this.allStates ? this.allStates[countryCode] : this.awaitingStatesPromise;
    }

    let newStateLookup: {[field: string]: IStateLookup[]};
    try {
      this.awaitingStatesPromise = (CheckoutRequestHandler as CheckoutRequestHandlerType).stateLookup(
        shopId,
        countryCode,
      );
      newStateLookup = {[countryCode]: await this.awaitingStatesPromise};
    } catch (err) {
      if ((err as Error & {response?: {status: number}}).response?.status !== 400) {
        throw err;
      }
      newStateLookup = {[countryCode]: []};
    }

    this.allStates = {...this.allStates, ...newStateLookup};
    // this will be done before the 'await this.awaitingStatesPromise'
    // of the second call proceeds. see 'try' block at the beginning
    this.awaitingStatesPromise = null;

    return this.allStates[countryCode];
  }
}

const statesHelper = new StatesHelper();
export {statesHelper as StatesHelper};
